import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { IconButton, Radio, Tooltip } from '@mui/material';
import { IDepartmentUpdateModel } from 'inputModels';
import { useState } from 'react';
import { useDrag } from 'react-dnd';
import { IDepartmentViewModel } from 'viewModels';
import { useTheme } from 'styled-components';
import { useDepartments } from '../../../context';
import { CompanyController } from '../../../controller/CompanyController';
import { ItemType } from '../../../types/enums';
import { Container } from './style';
import { useAlert } from '../../../hooks/useAlert';

interface CardDepartmentProps {
  id: string;
  name: string;
  isActivated: boolean;
  isDragabble: boolean;
  runningTutorial: boolean;
  onUpdateDepartment: (departmentUpdate: IDepartmentUpdateModel) => void;
  onCallback?: () => void;
  width?: number;
}
export function CardDepartment({
  id,
  name,
  isActivated,
  isDragabble,
  runningTutorial,
  onUpdateDepartment,
  onCallback,
  width,
}: CardDepartmentProps) {
  const theme = useTheme();
  const alert = useAlert();
  const { setDepartments } = useDepartments();
  const [isCheck, setIsCheck] = useState(isActivated);

  const updateDepartment = async (departmentUpdate: IDepartmentUpdateModel) => {
    const departmentUpdated: IDepartmentUpdateModel = {
      id: departmentUpdate.id,
      isActive: departmentUpdate.isActive,
      name: departmentUpdate.name,
    };
    if (!runningTutorial) {
      await CompanyController.updateDepartment(departmentUpdated)
        .then(() => {
          setDepartments((prevState) => {
            alert.show({ message: 'Departamento atualizado com sucesso!', type: 'success' });
            const newDepartaments = [...prevState];
            const index = newDepartaments.findIndex((d) => d.id === departmentUpdate.id);
            if (index !== -1) {
              newDepartaments[index].isActive = departmentUpdate.isActive;
            }
            return newDepartaments;
          });
        })
        .catch(() => {
          alert.show({
            message: 'Não foi possível atualizar o departamento. Tente novamente!',
            type: 'error',
          });
        });
    }
    onUpdateDepartment(departmentUpdated);
  };

  const [, drag] = useDrag({
    type: ItemType.DEPARTMENT,
    item: { id, name, isActivated },
    end: (item, monitor) => {
      monitor.getDropResult<IDepartmentViewModel>();
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  });

  return (
    <Tooltip disableInteractive title={name} placement="top-start" arrow>
      <Container ref={drag} width={width}>
        <div className="department-created" key={id}>
          <div className="department-name">
            {isCheck ? (
              <div className="name" style={{ color: theme.colors.secondary }} key={id}>
                {name}
              </div>
            ) : (
              <div className="name" style={{ color: 'gray' }}>
                {name}
              </div>
            )}
          </div>
          {!isDragabble && (
            <div className="department-options">
              <div className="radio-buttons" id="disable-department">
                <Radio
                  checked={isCheck}
                  onChange={() => {
                    updateDepartment({ id, isActive: true, name });
                    setIsCheck(true);
                  }}
                  name="radio-buttons"
                  inputProps={{ 'aria-label': 'A' }}
                />
                <p>Ativar</p>
                <Radio
                  checked={!isCheck}
                  onChange={() => {
                    updateDepartment({ id, isActive: false, name });
                    setIsCheck(false);
                  }}
                  name="radio-buttons"
                  inputProps={{ 'aria-label': 'B' }}
                />
                <p>Desativar</p>
              </div>
              <div className="icon-options">
                {isCheck ? (
                  <IconButton onClick={onCallback}>
                    <AccountBoxIcon />
                  </IconButton>
                ) : (
                  <IconButton disabled>
                    <AccountBoxIcon style={{ fill: ' gray' }} />
                  </IconButton>
                )}
              </div>
            </div>
          )}
        </div>
      </Container>
    </Tooltip>
  );
}
